module.exports = __webpack_public_path__ + "img/bg_user_info_vip.ceaf061f.png";